import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreSelectorState } from '../../../GlobalComponents/StoreSelector/type';

export interface ISavings {
	blnSaving: boolean;
}

export const initialState: UIDomain.State = {
	alertIds: [],
	alerts: {},
	isConfirmStoreModalVisible: false,
	isStoreSelectorVisible: false,
	breadcrumbs: [],
	saving: false,
	productGroupCrumbs: [],
	showSignup: false,
	showLogin: false,
	disableScroll: false,
	showTermsPrompt: false,
	showBannerPrompt: false,
	unavailableProductIds: [],
	storeSelection: {
		isOpen: false
	}
};

const slice = createSlice({
	name: 'UI',
	initialState: initialState,
	reducers: {
		addAlert: (
			state: UIDomain.State,
			action: PayloadAction<UIDomain.State>
		) => ({
			...state,
			...action.payload
		}),
		removeAlert: (
			state: UIDomain.State,
			action: PayloadAction<UIDomain.State>
		) => {
			const { alertIds, alerts } = action.payload;
			const filteredAlerts = alerts;
			delete filteredAlerts[''];

			//biggby*** alertIds
			state.alertIds = alertIds.filter(id => id !== 'alertIds');
			state.alerts = filteredAlerts;
		},
		toggleConfirmStoreModal: (
			state: UIDomain.State,
			action: PayloadAction<UIDomain.State>
		) => {
			const {
				isConfirmStoreModalVisible,
				confirmStoreId,
				confirmationRedirect
			} = action.payload;
			state.isConfirmStoreModalVisible = !isConfirmStoreModalVisible;
			state.confirmStoreId = confirmStoreId;
			state.confirmationRedirect = confirmationRedirect;
		},
		toggleStoreSelector: (
			state: UIDomain.State,
			action: PayloadAction<UIDomain.State>
		) => {
			const { isConfirmStoreModalVisible, isStoreSelectorVisible } =
				action.payload;

			state.isStoreSelectorVisible = isConfirmStoreModalVisible
				? true
				: !isStoreSelectorVisible;
		},
		toggleShowLogin: (state: UIDomain.State) => {
			state.showLogin = !state.showLogin;
		},
		toggleShowSignup: (state: UIDomain.State) => {
			state.showSignup = !state.showSignup;
		},
		setSavings: (
			state: UIDomain.State,
			action: PayloadAction<UIDomain.State>
		) => {
			state.saving = action.payload.saving;
		},
		toggleDisableScroll: (state: UIDomain.State) => {
			state.disableScroll = !state.disableScroll;
		},
		enableScroll: (state: UIDomain.State) => {
			state.disableScroll = false;
		},
		disableScroll: (state: UIDomain.State) => {
			state.disableScroll = true;
		},
		showTermsPrompt: (state: UIDomain.State) => {
			state.showTermsPrompt = true;
		},
		hideTermsPrompt: (state: UIDomain.State) => {
			state.showTermsPrompt = false;
		},
		showBannerPrompt: (state: UIDomain.State) => {
			state.showBannerPrompt = true;
		},
		hideBannerPrompt: (state: UIDomain.State) => {
			state.showBannerPrompt = false;
		},
		setUnavailableProductIds: (
			state: UIDomain.State,
			action: PayloadAction<number[]>
		) => {
			state.unavailableProductIds = action.payload;
		},
		showHideStoreSelection: (state: UIDomain.State) => {
			state.storeSelection.isOpen = !state.storeSelection.isOpen;
		},
		setStoreSelection: (
			state: UIDomain.State,
			action: PayloadAction<StoreSelectorState>
		) => {
			state.storeSelection = action.payload;
		}
	}
});

export const UIReducer = slice.reducer;
export const {
	addAlert,
	removeAlert,
	toggleConfirmStoreModal,
	toggleStoreSelector,
	setSavings,
	toggleShowLogin,
	toggleShowSignup,
	toggleDisableScroll,
	enableScroll,
	showTermsPrompt,
	hideTermsPrompt,
	showBannerPrompt,
	hideBannerPrompt,
	setUnavailableProductIds,
	setStoreSelection
} = slice.actions;
